export const PREMIUM_PAYMENT_MODAL = 'premium-payment-modal'
export const PREMIUM_PAYMENT_TARRIF_MODAL = 'premium-payment-tarrif-modal'
export const PROFILE_CONFIRM_MODAL = 'profile-confirm-modal'
export const PROFILE_DELETE_ACCOUNT_MODAL = 'profile-delete-account-modal'
export const PROFILE_CLEAR_HISTORY_MODAL = 'profile-clear-history-modal'
export const CREATIVE_DETAILS_MODAL = 'about-creative-modal'
export const FAVORITE_MODAL = 'favorite-modal'
export const FAVORITE_CREATE_GROUP_MODAL = 'favorite-create-group-modal'
export const FAVORITE_DELETE_GROUP_MODAL = 'favorite-delete-group-modal'
export const FAVORITE_MOVE_MODAL = 'favorite-move-modal'
export const FAVORITE_COPY_MODAL = 'favorite-copy-modal'
export const SAVE_PRESETS_MODAL = 'save-presets-modal'
export const FAVORITES_MODAL = 'favorites-modal'
export const RENAME_GROUP_MODAL = 'rename-favorites-modal'
export const CONFIRM_GROUP_MODAL = 'confirm-group-modal'
export const CONFIRM_FAVORITES_SAVED_FILTERS_MODAL =
  'confirm-favorites-saved-favorites-modal'
export const CONFIRM_FAVORITES_CLEAR_FILTERS_MODAL =
  'confirm-favorites-clear-filters-modal'

export const ACTIONS_BUTTONS_MODAL_MOBILE = 'actions-buttons-modal-mobile'
export const FEEDBACK_FORM_MODAL = 'feedback-form-modal'
export const ADD_GROUP_MODAL = 'add-group-modal'
export const AUTH_SOCIALS_MODAL = 'auth-socials-modal'
export const VERIFICATION_MODAL = 'verification-modal'
export const FILTERS_MOBILE_MODAL = 'filters-mobile-modal'
export const HISTORY_SAVED_FILTERS_MODAL = 'history-saved-filters-modal'
export const LIMIT_MODAL = 'limit-modal'
export const DATEPICKER_MOBILE_MODAL = 'datepicker-mobile-modal'
export const APPS_DETAILS_MODAL = 'apps-details-modal'
export const FEATURE_REQUEST_MODAL = 'feature-request-modal'
export const OFFERS_MODAL = 'offers-modal'
export const OFFERS_PREMIUM_MODAL = 'offers-premium-modal'
export const OFFERS_SEARCH_PREMIUM_MODAL = 'offers--search-premium-modal'
export const SEARCH_BAR_MODAL = 'search-bar-modal'
export const PROFILE_CONFIRM_SUBSCRIPTION_MODAL =
  'profile-confirm-subscription-modal'
export const PROFILE_CANCELLATION_MODAL = 'profile-cancellation-modal'
export const WELCOME_MODAL = 'welcome-modal'
export const FINISHED_ONBOARDING_MODAL = 'finished-onboarding-modal'
export const UPDATE_SUBSCRIPTION_MODAL = 'update-subscription-modal'
export const WELCOME_CLASSIC_SEARCH_MODAL = 'welcome-classic-search-modal'
